import {
    getCountries,
    getCountryCallingCode,
} from 'react-phone-number-input/input';
import ptBR from 'react-phone-number-input/locale/pt-BR.json';

export const countries = getCountries()
    .map((country) => ({
        id: country,
        name: ptBR[country],
        callingCode: getCountryCallingCode(country),
        flag: require(`./assets/${country}.svg`).default
    }))
    .sort((a, b) => a['name'].localeCompare(b['name']));

export function getCountryById(id) {
    return countries.find(c => c.id == id)
}